import { resolveUrl } from "@/lib/api";

export const TrustedMarquee = ({ logos = [] }) => {
  const items = [...logos, ...logos];
  return (
    <section className="bg-[var(--ink)] text-[var(--cream)] py-10 overflow-hidden marquee" data-testid="trusted-marquee">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-12">
        <p className="eyebrow text-[var(--terracotta)] shrink-0 sm:w-56">Trusted by 1,000+ stores<br className="hidden sm:block" /> for over 15 years</p>
        <div className="relative flex-1 overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_8%,#000_92%,transparent)]">
          <div className="marquee-track items-center gap-16">
            {items.map((l, i) => (
              <img key={i} src={resolveUrl(l.image_url)} alt={l.name} className="h-10 sm:h-12 w-auto object-contain" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
